module.exports = __webpack_public_path__ + "img/product.c8f34e94.png";